/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit TysiaIconPaid/view.blocks to change it.
import React from 'react'
import styles from './view.module.css'
import viewPath from './viewPath.js'



/**
 * @type {(
 *  props: {
 *    [x: string]: any,
 *    children?: React.ReactNode,
 *    viewPath: typeof viewPath
 *  }) => React.JSX.Element}
 */
export default function TysiaIconPaid({
  children,
  viewPath = "/DesignSystem/Svgs/TysiaIconPaid",
  alignSelf = "auto",
  marginTop = 0,
  marginBottom = 0,
  marginLeft = 0,
  marginRight = 0,
  opacity = 1,
  width = 24,
  height = 24,
  isAnimated,
  animation = "dash 5s linear forwards",
  strokeDashoffset = 1000,
  strokeDasharray = 1000,
  fill = "#323232"
  
}) {
  return (<React.Fragment
>
<svg
  data-testid="TysiaIconPaid.Svg"
  data-view-path={viewPath}
 viewBox="0 0 24 24"
 style={{'--as-1-IV0K': alignSelf,'--mt-2-IV0K': typeof marginTop === 'number' ? `${marginTop}px` : marginTop,'--mb-3-IV0K': typeof marginBottom === 'number' ? `${marginBottom}px` : marginBottom,'--ml-4-IV0K': typeof marginLeft === 'number' ? `${marginLeft}px` : marginLeft,'--mr-5-IV0K': typeof marginRight === 'number' ? `${marginRight}px` : marginRight,'--o-6-IV0K': opacity,'--w-10-IV0K': typeof width === 'number' ? `${width}px` : width,'--h-11-IV0K': typeof height === 'number' ? `${height}px` : height,'--a-7-IV0K': isAnimated ? animation : "none",'--sd-8-IV0K': isAnimated ? strokeDashoffset : 0,'--sd-9-IV0K': isAnimated ? strokeDasharray : 0}}
 className={`views-block ${styles.Svg}`}
>
<path
  data-testid="TysiaIconPaid.SvgPath"
  data-view-path={viewPath}
 d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm.89-8.9c-1.78-.59-2.64-.96-2.64-1.9 0-1.02 1.11-1.39 1.81-1.39 1.31 0 1.79.99 1.9 1.34l1.58-.67c-.15-.44-.82-1.91-2.66-2.23V5h-1.75v1.26c-2.6.56-2.62 2.85-2.62 2.96 0 2.27 2.25 2.91 3.35 3.31 1.58.56 2.28 1.07 2.28 2.03 0 1.13-1.05 1.61-1.98 1.61-1.82 0-2.34-1.87-2.4-2.09l-1.66.67c.63 2.19 2.28 2.78 3.02 2.96V19h1.75v-1.24c.52-.09 3.02-.59 3.02-3.22.01-1.39-.6-2.61-3-3.44z"
 style={{'--f-12-IV0K': fill}}
 className={`views-block ${styles.SvgPath}`}
/>
</svg>
{children}
</React.Fragment>)
}